import { CalculatorV2RegionConfigurationModel } from "../models/calculator-configuration";
import { CalculatorStep } from "../models/CalculatorStep";
import { mapQuestionsConfig } from "./question-config-mapper";

export function mapStepsConfig(
  steps: CalculatorStep[],
  config: CalculatorV2RegionConfigurationModel
): CalculatorStep[] {
  return steps.map((step) => {
    if (!config.Steps[step.field]) {
      console.debug("No step available for", step.field);
      return step;
    }

    return {
      ...step,
      title: config.Steps[step.field].Title,
      description: config.Steps[step.field].Description,
      questions: mapQuestionsConfig(step.questions, config.Steps[step.field]),
    };
  });
}
